import React from 'react';
import { Colors } from 'library';
import { Avatar, Card, IconButton, Row, Stack, Text } from 'library/ui';
import { Create, Error } from '@mui/icons-material';
import type { SvgIconComponent } from '@mui/icons-material';

import type { IWorkerTab } from '../types';

export function WorkerTab({
    worker,
    onClick,
    action,
    icon,
    attention,
}: {
    worker: IWorkerTab;
    onClick: () => void;
    action?: React.ReactNode;
    icon?: SvgIconComponent;
    attention?: boolean;
}) {
    return (
        <Card padding="sm">
            <Row justify="between" align="center">
                <Row gap="sm" align="center">
                    <Avatar
                        imageUrl={worker.profile_image?.image}
                        initials={`${worker.user.first_name[0]}${worker.user.last_name[0]}`}
                    />
                    <Stack gap="none">
                        <Text weight="semibold">
                            {worker.user.first_name} {worker.user.last_name}{' '}
                            {attention && <Error sx={{ color: Colors.error, fontSize: 18 }} />}
                        </Text>
                        {!!worker.middle && (
                            <Text size="xs" component="div">
                                {worker.middle}
                            </Text>
                        )}
                        {!!worker.bottom && (
                            <Text size="xs" component="div">
                                {worker.bottom}
                            </Text>
                        )}
                    </Stack>
                </Row>
                {action ?? <IconButton icon={icon || Create} onClick={onClick} />}
            </Row>
        </Card>
    );
}
